import Parent from '../views/Parent.vue';
import DasboardProfiling from '../views/dashboard-profiling/DasboardProfiling.vue';

const dasboardProfilingRoute = {
  path: '/dashboard-profiling',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Dashboard Profiling',
        appBarTitle: 'Dashboard Profiling',
      },
      component: DasboardProfiling,
      name: 'DasboardProfiling',
    },
  ],

  meta: {
    title: 'BNI QRIS - Dashboard Profiling',
    appBarTitle: 'Dashboard Profiling',
  },
  component: Parent,
};

export default dasboardProfilingRoute;
